import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";


const getInvoiceNumber = {
    namespaced: true,
    state: {
        invoiceNumber: '',
    },
    mutations: {
        SUCCESS_GET_INVOICE_NUMBER(state, response) {
            state.invoiceNumber = response.data;
        },
        FAILURE_GET_INVOICE_NUMBER(state, error) {
            console.log(error);
        },
    },
    actions: {
        getInvoiceNumber: function({ dispatch }, payload = {}) {

            const data = {};
            if (payload.invoiceType) {
                data.invoiceType = payload.invoiceType
            }

            const url = payload.invoiceId ? config.baseURLApi + "/invoices/invoiceNumber/" + payload.invoiceId : config.baseURLApi + "/invoices/invoiceNumber";

            let promise = sendRequest("get", url, {}, {}, true, data);
            promise.then(function (result) {
                if(result[0] === "success") {
                    dispatch("successGetInvoiceNumber", result[1]);
                } else {
                    dispatch("failureGetInvoiceNumber", result[1]);
                }
            })
        },
        successGetInvoiceNumber: function({ commit }, response) {
            commit("SUCCESS_GET_INVOICE_NUMBER", response);

        },
        failureGetInvoiceNumber: function({ commit }, response) {
            commit("FAILURE_GET_INVOICE_NUMBER", response);
        },

    }
}

export default getInvoiceNumber;